import 'css-chunk:src/components/button/button-component.module.scss';export default {
  "button-component": "button-component_button-component__Q1Ue2",
  "disabled": "button-component_disabled__PnyTE",
  "primary": "button-component_primary__fm3fv",
  "secondary": "button-component_secondary__FJeNC",
  "tertiary": "button-component_tertiary__qzHAG",
  "outline": "button-component_outline__rWJfd",
  "outline-white": "button-component_outline-white__p40dM",
  "link": "button-component_link__ia-Eb",
  "text": "button-component_text__0M7v4",
  "link-white": "button-component_link-white__GB9Jv",
  "ghost": "button-component_ghost__3RqQM",
  "full-width": "button-component_full-width__vlj62",
  "default": "button-component_default__id1n-",
  "icon-button": "button-component_icon-button__U624R",
  "small-icon": "button-component_small-icon__l5juc",
  "icon": "button-component_icon__wbmY7",
  "loader": "button-component_loader__cW-Ya",
  "tooltip": "button-component_tooltip__zdZ2M",
  "icon-right": "button-component_icon-right__InbZb",
  "text-only-alignment": "button-component_text-only-alignment__WYGVC"
};